<script setup lang="ts">
import { PhFolderDashed, PhMagnifyingGlass } from '@phosphor-icons/vue';
import { useI18n } from 'vue-i18n';
import { FileManagerNotice } from '../../../../sub-components/notice';

// Both states render "the list is empty", but they mean different things and only one of them is
// about the folder: with a search active the folder may well have contents, they just don't match.
// Saying "this folder is empty" there would be plainly wrong, hence the split rather than a single
// message.
defineProps<{ isFiltered?: boolean }>();

const { t } = useI18n();
</script>

<template>
  <FileManagerNotice
    v-if="isFiltered"
    :icon="PhMagnifyingGlass"
    :heading="t('fileManager.fileExplorerView.noSearchResultsHeading')"
    :message="t('fileManager.fileExplorerView.noSearchResultsDescription')"
  />
  <FileManagerNotice
    v-else
    :icon="PhFolderDashed"
    :heading="t('fileManager.fileExplorerView.emptyFolderHeading')"
    :message="t('fileManager.fileExplorerView.emptyFolderDescription')"
  />
</template>
